function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-482.074 -271.415)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M488.427,304.5h51.164v-6.853H488.427Z",
  transform: "translate(7.486 30.914)",
  fill: "#ffeb39"
}), /*#__PURE__*/React.createElement("path", {
  d: "M560.952,286.162a7.566,7.566,0,0,1-1.614,3.516,5.7,5.7,0,0,1-4.237,1.893q-.542,2.5-1.085,5-3.238,15.037-6.461,30.075c-.133.623-.479.6-.932.6q-10.783-.007-21.566,0-14.286,0-28.574.011c-.636,0-.915-.142-1.061-.83q-3.65-17.148-7.363-34.286c-.039-.174-.1-.344-.159-.569a5.859,5.859,0,0,1-3.941-1.616c-3.324-3.165-2.052-9.143,2.259-10.548a5.572,5.572,0,0,1,6.853,3.806,6.484,6.484,0,0,1-2.3,7.444c.83,1.155,1.634,2.335,2.5,3.47a31.211,31.211,0,0,0,8.452,8.208,13.863,13.863,0,0,0,2.207,1.076c1.96.745,3.612-.026,5.137-1.2a17.151,17.151,0,0,0,3.777-4.333,71.966,71.966,0,0,0,6.827-14.452,6.166,6.166,0,0,1-3.466-3.666,6.531,6.531,0,0,1,2.259-7.415,5.528,5.528,0,0,1,8.374,3.085,6.5,6.5,0,0,1-3.516,8.047c.884,2.167,1.717,4.365,2.671,6.511a41.546,41.546,0,0,0,5.734,9.973,17.176,17.176,0,0,0,2.584,2.512c2.226,1.745,4.5,1.418,6.788.017a27.445,27.445,0,0,0,6.808-6.069c1.518-1.836,2.917-3.771,4.4-5.712-.251-.222-.416-.368-.58-.518a6.225,6.225,0,0,1-2-6.208,5.761,5.761,0,0,1,4-4.575,5.6,5.6,0,0,1,6.882,3.88c.118.388.227.778.34,1.168Z",
  transform: "translate(0 0)",
  fill: "#ffeb39"
}), /*#__PURE__*/React.createElement("path", {
  d: "M488.427,304.5v-6.853h51.164V304.5Z",
  transform: "translate(7.486 30.914)",
  fill: "#ffeb39"
}));

var SvgPremium = function SvgPremium(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78.878,
    height: 64.001,
    viewBox: "0 0 78.878 64.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPremium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/premium.9255b1fd.svg";
export { ForwardRef as ReactComponent };